import { render, staticRenderFns } from "./available-services.vue?vue&type=template&id=e63ecebe&scoped=true&"
import script from "./available-services.vue?vue&type=script&lang=tsx&"
export * from "./available-services.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63ecebe",
  null
  
)

export default component.exports